import {useContext} from "react";
import {VariablesContext} from "./VariablesContext";

const useVariables = () => {
    return useContext(VariablesContext)
}

export default useVariables